import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import useMainNavigationStore from "../stores/useMainNavigationStore";
import useMainNavigationAllItems from "./useAllMenuItems";
import { checkIsActive, findGroupForMenuItem } from "../helpers";

const useMainNavigationActiveStates = () => {
  const location = useLocation();
  const pinnedItemIds = useMainNavigationStore((state) => state.pinnedItemIds);

  const { allMenuItems, allNavigationItems } = useMainNavigationAllItems();

  const pathname = location.pathname;

  return useMemo(() => {
    const activeMenuItem = allMenuItems.find((item) => checkIsActive(pathname, item.routeRule));

    const activeGroupId = findGroupForMenuItem(activeMenuItem?.id, allNavigationItems);
    const isPinnedGroupActive = !!activeMenuItem && pinnedItemIds.includes(activeMenuItem.id);

    return {
      activeMenuItemId: activeMenuItem?.id,
      activeGroupId,
      isPinnedGroupActive,
    };
  }, [pathname, allMenuItems, allNavigationItems, pinnedItemIds]);
};

export default useMainNavigationActiveStates;
